import "./App.css";
import Routers from "./routes";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Routers />
  );
}

export default App;
